import { useEffect, useState } from "react";
import { User } from "lucide-react";
import { api } from "../lib/api";

const cache = {};
export const setAvatarCache = (uid, img) => { cache[uid] = img; window.dispatchEvent(new CustomEvent("avatar-changed", { detail: uid })); };

export function Avatar({ uid, src, size = "w-9 h-9", className = "", testid }) {
  const [img, setImg] = useState(src ?? cache[uid] ?? "");
  useEffect(() => {
    if (src !== undefined) { setImg(src); return; }
    if (!uid) { return; }
    if (cache[uid] === undefined) {
      cache[uid] = "";
      api(`/web/avatar?uid=${uid}`).then((r) => setAvatarCache(uid, r.image || "")).catch(() => {});
    }
    const on = (e) => { if (e.detail === uid) { setImg(cache[uid]); } };
    window.addEventListener("avatar-changed", on);
    setImg(cache[uid]);
    return () => window.removeEventListener("avatar-changed", on);
  }, [uid, src]);
  return img
    ? <img src={img} alt="Foto profilo" className={`${size} rounded-full object-cover shrink-0 ${className}`} data-testid={testid} />
    : <span className={`${size} rounded-full bg-[var(--navy)] text-white flex items-center justify-center shrink-0 ${className}`} data-testid={testid}><User className="w-1/2 h-1/2" /></span>;
}
